/* eslint-disable @nx/enforce-module-boundaries */
import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { appRoutes } from '@tekman/onmat/constants';
import { demoGuard, isAuthenticatedGuard, isOnmatGroup, isRoleGuard, profileGuard, LicensesGuard } from '@tekman/onmat/utils';

// Guard order is load-bearing: canActivate guards run in parallel and the router honours
// the redirect of the first one in the array that does not return true, so LicensesGuard
// (error/license) wins over profileGuard (error/group), and profileGuard is declared before
// the guards that wait for the profile so its redirect is not blocked by them.
const routes: Routes = [
  {
    path: appRoutes.activities,
    loadChildren: () => import('apps/onmat-zero/src/app/route-handler.module').then(m => m.RouteHandlerModule),
    canActivate: [isAuthenticatedGuard, LicensesGuard, profileGuard],
  },
  {
    path: appRoutes.itineraries,
    loadChildren: () => import('./itinerary/itinerary-route-handler.module').then(m => m.ItineraryRouteHandlerModule),
    canActivate: [isAuthenticatedGuard, LicensesGuard, profileGuard],
  },
  {
    path: appRoutes.contents,
    loadChildren: () => import('./content/content.module').then(m => m.ContentModule),
    canActivate: [isAuthenticatedGuard, LicensesGuard, profileGuard],
  },
  {
    path: appRoutes.groups,
    loadChildren: () => import('./groups/groups.module').then(m => m.GroupsModule),
    canActivate: [isAuthenticatedGuard, LicensesGuard, profileGuard, isRoleGuard, demoGuard],
  },
  {
    path: appRoutes.resources,
    loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule),
    canActivate: [isAuthenticatedGuard, LicensesGuard, profileGuard, isOnmatGroup],
  },
  {
    path: appRoutes.tracking,
    loadChildren: () => import('./teacher/tracking/tracking-route-handler.module').then(m => m.TrackingRouteHandlerModule),
    canActivate: [isAuthenticatedGuard, LicensesGuard, profileGuard],
  },
  {
    path: appRoutes.error,
    loadChildren: () => import('@tekman/onmat/component/onmat').then(m => m.OnmatComponentModule),
    canActivate: [isAuthenticatedGuard],
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: appRoutes.itineraries,
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: appRoutes.itineraries,
  },
  {
    path: 'callback',
    pathMatch: 'full',
    redirectTo: appRoutes.itineraries,
  },
  {
    path: 'login',
    pathMatch: 'full',
    redirectTo: appRoutes.itineraries,
  },
  { path: '**', redirectTo: appRoutes.error404, pathMatch: 'full' },
];

const options: ExtraOptions = {
  enableTracing: false,
  scrollPositionRestoration: 'top',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, options)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
